import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import styled from '@emotion/styled';
import { Box } from '@mui/material';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledStepLine = styled(Box, {
  shouldForwardProp: isStyledPropsValid
})(_ref => {
  let {
    theme,
    active,
    width
  } = _ref;
  return {
    borderTop: active ? "1px solid ".concat(theme.customColors.purple[500]) : "1px dashed ".concat(theme.customColors.grey[500])
  };
});
const StyledStepDotContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid
})(_ref2 => {
  let {
    theme,
    active,
    sx
  } = _ref2;
  return _objectSpread2({
    color: active ? '#7B61FF' : '#A5A5A5',
    position: 'absolute',
    bottom: '-4px',
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    transform: 'translate(-50%, 0%)',
    whiteSpace: 'nowrap',
    fontSize: '12px'
  }, sx);
});
const StyledStepDot = styled(Box, {
  shouldForwardProp: isStyledPropsValid
})(_ref3 => {
  let {
    theme,
    active,
    overStep,
    sx
  } = _ref3;
  return _objectSpread2({
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: overStep ? theme.customColors.purple[500] : '#FAFAFD',
    border: active ? "1px solid ".concat(theme.customColors.purple[500]) : "1px solid ".concat(theme.customColors.grey[500])
  }, sx);
});
export { StyledStepDot, StyledStepDotContainer, StyledStepLine };